// extracted by mini-css-extract-plugin
export default {"writePostBtnWrapper":"jnQyQXFAURNZuxb6UpLw","writePostBtn":"EMJs5V8oFMbyvMiz9Zwg"};